import axios from "axios";
import httpRequest from "../httpRequest";
import { getTotalCount, paramsRequest } from "../../utils/utils";

export const getAllService = async () => {
  try {
    const { data } = await httpRequest.post("services/search", paramsRequest);
    return await getTotalCount(data.totalCount, "services/search");
  } catch (error) {
    return JSON.parse(error);
  }
};
export const getSearchService = async (filters) => {
  try {
    return await httpRequest.post("services/search", filters);
  } catch (error) {
    return JSON.parse(error);
  }
};

export const generateServices = async (request) => {
  try {
    const { data } = await httpRequest.post("services/search", request);
    const newData = data.data.reduce((acc, item) => {
      acc.push({ ...item });
      return acc;
    }, []);
    return { ...data, data: newData };
  } catch (error) {
    return JSON.parse(error);
  }
};

export const createService = async (request) => {
  try {
    return await httpRequest.post("services/create", request);
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const updateService = async (request, id) => {
  try {
    return await httpRequest.update("services", id, request);
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const activateService = async (request) => {
  try {
    return await httpRequest.post("services/activate", request);
  } catch (error) {
    return JSON.parse(error);
  }
};

export const desActivateService = async (request) => {
  try {
    return await httpRequest.post("services/desactivate", request);
  } catch (error) {
    return JSON.parse(error);
  }
};

export const getServiceWithoutTokenService = async (tenant) => {
  try {
    return await httpRequest.post("services/searchbytenant", paramsRequest, {
      headers: { tenant },
    });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const getDocuments = async (tenant) => {
  try {
    return await httpRequest.post("tdocuments/searchbytenant", paramsRequest, {
      headers: { tenant },
    });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const uploadDocumentAnonymous = async (tenant, documentToUpload) => {
  try {
    return await httpRequest.post("documents/createanonymous", documentToUpload, {
      headers: { tenant },
    });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const uploadDocument = async (tenant, documentToUpload) => {
  try {
    return await httpRequest.post("documents/create", documentToUpload, {
      headers: { tenant },
    });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const getDocumentsByCustomer = async (idCustomer) => {
  try {
    return await httpRequest.post("documents/search", { customerId: idCustomer });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const revisionDocument = async (idDocument, data) => {
  try {
    return await httpRequest.put(`documents/${idDocument}/revision`, data);
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const uploadDocumentCustomer = async (tenant, documentToUpload) => {
  try {
    return await httpRequest.post("documents/createcustomer", documentToUpload, {
      headers: { tenant },
    });
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};

export const upload = async (content, document, url, onUploadProgress) => {
  try {
    const config = {
      method: "put",
      url,
      headers: {
        "x-ms-blob-type": "BlockBlob",
        "Content-Type": content,
      },
      data: document,
      onUploadProgress: (value) => onUploadProgress((value.loaded * 100) / value.total),
    };
    /* eslint-disable no-console */
    axios(config)
      .then((response) => console.log(JSON.stringify(response.data)))
      .catch((error) => console.log(error));
    /* eslint-disable no-console */
  } catch (error) {
    const { dataError } = error;
    throw dataError;
  }
};
